import * as z from 'zod';
import { OpenAPIV3 } from 'openapi-types';
import { AxiosPromise, ResponseType, AxiosRequestConfig } from 'axios';

export type ConnectionKind = 'openapi';

export const connectionKind = z.enum(['openapi']);

export interface ConnectionSpec {
  name: string;
  kind: ConnectionKind;
}

export const connectionSpec = z.object({
  name: z.string(),
  kind: connectionKind
});

export interface Connection {
  readonly id: string;

  request(path: string, args?: RequestArgs): AxiosPromise<any>;
  ajax(config: AxiosRequestConfig): AxiosPromise<any>;
}

export interface RequestArgs {
  method?: string;
  parameters?: Dictionary<any>;
  content?: object;
  contentType?: string;
  responseType?: ResponseType;
  headers?: Dictionary<any>;
  language?: string;
}

export interface OpenapiDescriptor {
  id: string;
  name: string;
  url: string;
  baseUrl: string;
  headers?: object;
}

export interface OpenapiConnectionSpec extends ConnectionSpec {
  url: string;
  baseUrl: string;
  headers?: {
    [name: string]: string;
  };
  schema?: OpenAPIV3.Document;
}

export const openapiConnectionSpec = connectionSpec.extend({
  url: z.string(),
  baseUrl: z.string(),
  headers: z.record(z.string(), z.any()).optional(),
  schema: z.any().optional()
});

export interface OpenapiOperationParameter {
  schema?: object;
  required: boolean;
  name: string;
  in: 'header' | 'path' | 'query';
}

export interface OpenapiOperation {
  url: string;
  method: string;
  summary: string;
  operationId: string;
  parameters?: OpenapiOperationParameter[];
  requestBody?: object;
  responses?: object;
}
